export const selectIsAuthCheckLoading = (state) => state.auth.isAuthCheckLoading
export const selectIsAuthCheckUsingTokenLoading = (state) => state.auth.isAuthCheckUsingTokenLoading
export const selectUser = (state): User => state.auth.user
export const selectContext = (state): Context => state.auth.context
